import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function NewsDetailsPage() {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/news/${id}`)
      .then(res => res.json())
      .then(data => setNewsItem(data))
      .catch(err => console.error(err));
  }, [id]);

  // Dinámicamente insertar etiquetas OG y Twitter
  useEffect(() => {
    if (newsItem) {
      document.title = newsItem.title;

      const setMetaTag = (property, content) => {
        let tag = document.querySelector(`meta[property='${property}']`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute('property', property);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
      };

      setMetaTag('og:title', newsItem.title);
      setMetaTag('og:description', newsItem.content?.substring(0, 150) + '...');
      setMetaTag('og:image', newsItem.imageUrl);
      setMetaTag('og:url', window.location.href);
      setMetaTag('og:type', 'article');

      setMetaTag('twitter:card', 'summary_large_image');
      setMetaTag('twitter:title', newsItem.title);
      setMetaTag('twitter:description', newsItem.content?.substring(0, 150) + '...');
      setMetaTag('twitter:image', newsItem.imageUrl);
    }
  }, [newsItem]);

  if (!newsItem) return <p style={{ padding: '20px' }}>Cargando...</p>;

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2 style={{ fontSize: '28px', marginBottom: '16px' }}>{newsItem.title}</h2>

      <img
        src={newsItem.imageUrl || '/images/default-news.jpg'}
        alt={newsItem.title}
        className="news-detail-image"
        style={{
          maxWidth: '600px',
          width: '100%',
          height: 'auto',
          display: 'block',
          margin: '0 auto 20px auto',
          borderRadius: '8px',
          objectFit: 'contain',
        }}
      />


      <div
        style={{ fontSize: '18px', lineHeight: '1.6' }}
        dangerouslySetInnerHTML={{ __html: newsItem.content }}
      />
    </div>
  );
}

export default NewsDetailsPage;
